// extracted by css-extract-rspack-plugin
export default {"epochTimestamp":"U0HY5l88g0EI4yMX"};